import DatePicker from 'react-datepicker';
import { useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';

import useIsMobile from 'Hook/useIsMobile';
import { TextBold } from 'UiKit/typography';
import { CalendarIcon, DoubleChevronLeftIcon, DoubleChevronRightIcon } from 'Asset/icon';

import styles from './styles.module.css';
import './styles.css';

const FilterYearMonthPicker = ({
  value,
  onChange = () => {},
  width = '168px',
  height = '34px',
  dateFormat = 'MMMM yyyy',
  popperPlacement = 'bottom',
  placeholder,
  ...props
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [showYearPicker, setShowYearPicker] = useState(false);
  const onOpenDatePicker = () => onOpen();
  const isMobile = useIsMobile();

  const onSelectDatePicker = (value) => {
    if (showYearPicker) {
      setShowYearPicker(false);
    } else {
      onChange(value);
      onClose();
    }
  };

  const onClickOutside = () => {
    setShowYearPicker(false);
    onClose();
  };

  const CustomHeader = (props) => {
    const { decreaseYear, increaseYear } = props;
    return (
      <Flex className={styles['custom-header__container']}>
        <Box onClick={() => decreaseYear()} className={styles['custom-header__picker']}>
          <DoubleChevronLeftIcon
            color="var(--color-neutral40)"
            style={{
              pointerEvents: 'none',
            }}
          />
        </Box>
        <Box onClick={() => setShowYearPicker(true)} className={styles['custom-header__picker']}>
          <TextBold>{props.date.getFullYear()}</TextBold>
        </Box>
        <Box onClick={() => increaseYear()} className={styles['custom-header__picker']}>
          <DoubleChevronRightIcon
            color="var(--color-neutral40)"
            style={{
              pointerEvents: 'none',
            }}
          />
        </Box>
      </Flex>
    );
  };

  const renderYearContent = (year) => {
    return <Box className={styles['year-month-picker__year-content']}>{year}</Box>;
  };

  return (
    <Box className={`year-month-picker__container ${styles['year-month-picker__container']}`} width={width} height={height}>
      <DatePicker
        selected={value}
        showMonthYearPicker={!showYearPicker}
        showYearPicker={showYearPicker}
        dateFormat={dateFormat}
        yearItemNumber={12}
        open={isOpen}
        onSelect={onSelectDatePicker}
        onInputClick={onOpen}
        onClickOutside={onClickOutside}
        placeholder={placeholder}
        placeholderText={placeholder}
        showPopperArrow={false}
        renderYearContent={renderYearContent}
        renderCustomHeader={CustomHeader}
        popperPlacement={popperPlacement}
        calendarClassName={styles['year-month-picker__calendar-classname']}
        onKeyDown={(e) => {
          e.preventDefault();
        }}
        {...props}
      />
      <CalendarIcon className="calendar__icon" color="var(--color-neutral70)" size={!isMobile ? '22px' : '16px'} onClick={onOpenDatePicker} />
    </Box>
  );
};

export default FilterYearMonthPicker;
